"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disallowAdditionalProperties = exports.stripSchemaFormats = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var forEach_1 = __importDefault(require("lodash/forEach"));
exports.stripSchemaFormats = function (schema, whitelist) {
    if (whitelist === void 0) { whitelist = []; }
    var newSchema = cloneDeep_1.default(schema);
    var _strip = function (schema) {
        if (schema.format && whitelist.indexOf(schema.format) === -1) {
            delete schema.format;
        }
        if (schema.properties) {
            forEach_1.default(schema.properties, function (subSchema) {
                _strip(subSchema);
            });
        }
        if (schema.items) {
            _strip(schema.items);
        }
    };
    _strip(newSchema);
    return newSchema;
};
exports.disallowAdditionalProperties = function (schema) {
    var newSchema = cloneDeep_1.default(schema);
    var disallow = function (schema) {
        if (schema.additionalProperties) {
            schema.additionalProperties = false;
        }
        if (schema.properties) {
            forEach_1.default(schema.properties, function (subSchema) {
                disallow(subSchema);
            });
        }
    };
    disallow(newSchema);
    return newSchema;
};
